import React from 'react';
import Lawyers from './LawyersContactedContainer';
import './LawyersContacted.scss';

const LawyersContacted = props => (
  <div style={{maxWidth: 1360, backgroundColor: '#f6f8fb', margin: 'auto'}}>
    <Lawyers />
  </div>
);

export default LawyersContacted;
